const legals = [
    {
        heading: "Discaimer",
        caption: "The following disclaimers apply to Wefreelancer Global Tech (Supelle), a US-based company (herein referred to as “we,” “us,” or “our”)...",
        body: `<div>
        <h6 class="bold">Disclaimers</h6>
        <p>
          The following disclaimers apply to Wefreelancer Global Tech (Supelle), a
          US-based company (herein referred to as “we,” “us,” or “our”). By accessing
          or using our website, products, or services, you acknowledge that you have
          read, understood, and agree to be bound by the terms and conditions of this
          disclaimer.
        </p>
        <h6 class="bold mt-5">Risk Warning</h6>
        <p>See our <a href="#">"Risk Disclosure</a></p>
        <p>
          We would like to reiterate that you should only purchase Supchain tokens if
          you fully understand the tokenomics of Supchain supply and issuance and the
          Supchain economy. Because of the immutable nature of blockchain transactions
          and the lack of uniform regulation for crypto assets, there may be no remedy
          if assets expire or a successful theft or attack by malicious actors were to
          take place against the Ethereum chain that the Supchain  platform is built on.
        </p>
        <p>
          Each prospective Supchain purchaser should weigh up their own individual
          appetite for risk and consider consulting an independent financial adviser,
          tax professional, accountant, or lawyer before making any decisions.
        </p>
      
        <h6 class="bold mt-5">Information Accuracy</h6>
        <p>
          We strive to ensure that the information on our website is accurate and
          up-to-date. However, we do not guarantee the accuracy, completeness, or
          timeliness of any information or data on our website or in our products or
          services. We are not responsible for any errors or omissions or for any loss
          or damage arising from reliance on the information provided.
        </p>
        <p>
          Our website may contain links to third-party websites or resources. We are
          not responsible for the content or accuracy of any third-party websites or
          resources, and we do not endorse or assume any liability for any actions
          taken or decisions made based on the content or information on those
          websites or resources.
        </p>
      
        <h6 class="bold mt-5">Legal Disclaimer</h6>
        <p>
          We do not provide legal, tax, or contribution advice, and the information on
          our website, products, and services should not be construed as such. You
          should consult with a licensed professional before making any investment
          decisions or taking any legal or tax actions. We do not endorse or recommend
          any particular cryptocurrency, contribution strategy, or third-party provider,
          and we do not guarantee the performance of any cryptocurrency or contribution.
        </p>
      
        <h6 class="bold mt-5">Listings.</h6>
        <p>
          We do not make any representations or warranties about whether a
          cryptocurrency or other digital asset will be listed on our platforms or
          that those listed will always continue to be listed. Furthermore, any
          cryptocurrency or digital asset currently available on our platform is
          subject to delisting without prior notice at our sole discretion.
        </p>
      
        <h6 class="bold mt-5">Limitation of Liability</h6>
        <p>
          To the extent permitted by law, we will not be liable for any direct,
          indirect, incidental, consequential, or punitive damages arising from or
          related to the use of our website, products, or services. This includes but
          is not limited to, damages for lost profits, lost revenue, or loss of data.
        </p>
      
        <h6 class="bold mt-5">Indemnification</h6>
        <p>
          You agree to indemnify, defend, and hold harmless Wefreelancer Global Tech
          (Supelle), its affiliates, officers, directors, employees, agents, and
          licensors from any claims, damages, liabilities, costs, and expenses
          (including reasonable attorneys’ fees) arising from or related to your use
          of our website, products, or services, your violation of these terms and
          conditions, or your violation of any rights of another.
        </p>
      
        <h6 class="bold mt-5">Governing Law and Jurisdiction</h6>
        <p>
          This disclaimer and your use of our website, products, and services will be
          governed by and construed in accordance with the laws of the United States.
        </p>
      
        <h6 class="bold mt-5">Modification</h6>
        <p>
          We may modify or update this disclaimer at any time without prior notice. By
          continuing to use our website, products, or services after any such changes,
          you acknowledge and agree to be bound by the updated terms and conditions.
        </p>
      
        <h6 class="bold mt-5">Contact Us</h6>
        <p>
          If you have any questions or concerns about this disclaimer, please contact
          us at <a href="/support">http://supchain.io/support/index.html</a>
        </p>
      
        <h6 class="bold mt-5">Does not make groundless assumptions:</h6>
        <p>
          Forecasts for Supchain should be approached with a grounded and realistic
          perspective, avoiding groundless assumptions.
        </p>
        <p>
          While the project holds immense potential, it is essential to consider
          various factors that can impact the future trajectory of Supchain.
        </p>
        <p>
          These include market dynamics, regulatory developments, and competition
          within the cryptocurrency space. A prudent forecast acknowledges the
          challenges and uncertainties inherent in the crypto market, ensuring that
          expectations align with the project's progress, market conditions, and user
          adoption. It is crucial to consider Supelle's continuous innovation, the
          community's response, and the ability to navigate potential obstacles along
          the way.
        </p>
        <p>
          By staying informed, analyzing trends, and monitoring the project's growth,
          forecasts for Supchain can be made with a balanced outlook that takes into
          account both the project's potential and the broader market dynamics. This
          approach ensures a realistic assessment of Supchain's future prospects while
          avoiding unfounded assumptions that may undermine the credibility of the
          forecast.
        </p>
      
        <p class="mt-5">
          <span class="bold">Global Reach:</span> With the ability to be issued and
          traded globally, ERC20 tokens enable companies and organizations to access a
          worldwide contributor base. This eliminates traditional fundraising methods and
          opens up new opportunities.
        </p>
        <p class="mt-5">
          <span class="bold">Liquidity:</span> ERC20 tokens can be easily traded on
          cryptocurrency exchanges, providing liquidity for token holders. This allows
          them to buy or sell their tokens, enhancing their marketability
          conveniently.
        </p>
        <p class="mt-5">
          <span class="bold">Lower Costs:</span> Compared to traditional fundraising
          methods like IPOs, issuing ERC20 tokens often costs less. This affordability
          extends across transaction costs, contributing to a more cost-effective
          ecosystem for all participants.
        </p>
      
        <p>
          The Decentralized Freelance Marketplace Ecosystem, built on the Ethereum
          Blockchain, represents the future of global freelancing, enabling a
          streamlined and democratized entry into the freelance industry by
          eliminating intermediaries and centralized authorities.
        </p>
      
        <p>
          The decentralized nature of the ecosystem ensures security, transparency,
          and high efficiency by connecting directly to the blockchain instead of
          relying on centralized servers. This approach breaks down barriers, offering
          unparalleled flexibility, equality, and access to work opportunities
          worldwide.
        </p>
      
        <h6 class="bold mt-5">Supelle Secured Ecosystem:</h6>
        <ul>
          <li>Full Decentralization</li>
          <li>High Resistance to attacks</li>
          <li>Liquidity-locking mechanisms</li>
          <li>Time-locked contracts</li>
        </ul>
      
        <h6 class="bold mt-5">For contributors:</h6>
      
        <p>
          Contributors to the Supelle project, which may include developers, community
          members, and strategic partners, also derive value from Supchain. As
          contributors actively participate in the growth and development of the
          ecosystem, holding Supchain grants them various benefits. This may
          include opportunities for staking or participating in governance decisions,
          where they can have a direct impact on the project's trajectory.
        </p>
      
        <p>
          Supchain acts as an incentive for contributors, rewarding their
          contributions with tangible value within the ecosystem. By holding Supelle
          Coin, contributors can participate in the decision-making process, shape the
          future direction of the project, and gain access to exclusive features or
          benefits. This value proposition fosters a vibrant and engaged community,
          where contributors and developers are recognized and incentivized for their
          efforts.
        </p>
      
        <p>
          Moreover, as the Supelle ecosystem expands and gains adoption, the value of
          Supelle Coin may appreciate over time. Early contributors and long-term
          holders may benefit from the potential increase in the token's value,
          further enhancing the value proposition for contributors.
        </p>
      
        <h6 class="mt-5 bold">In summary</h6>
        <p>
          Supchain provides value to both the project's audience, consisting of
          freelancers and clients, and contributors to the Supelle ecosystem. It
          empowers freelancers by enabling efficient payments and enhances the
          experience for clients by streamlining transactions. Additionally,
          contributors benefit from their involvement in the project through
          participation in governance decisions and potential appreciation of the
          token's value.
        </p>
      
        <p>
          Supchain's value proposition supports the growth, engagement, and
          success of the Supelle ecosystem as a whole. When using ICO offerings in the
          freelance marketplace, there are several legal considerations to keep in
          mind. These are some of the legal considerations: Regulatory Compliance:
          ICOs are subject to regulatory compliance, and companies must ensure that
          they comply with the relevant territorial laws that govern how these
          transactions must be held
        </p>
      
        <p>
          Failure to comply with these regulations can result in legal consequences.
        </p>
      
        <p>
          1 Anti-Money Laundering and Know-Your-Customer Laws: Once a company is SEC
          registered, any ICO tokens it offers must comply with anti-money laundering
          laws and know-your-customer laws too
        </p>
      
        <p>
          2 Transparency: ICOs must be transparent about the project's goals, the use
          of funds, and the risks involved . Companies must provide clear and accurate
          information to contributors to avoid legal consequences.
        </p>
      
        <p>
          Failure to do so can result in legal consequences. <br> 4 Contractual
          Obligations: Companies must ensure that they fulfill their contractual
          obligations to contributors Failure to do so can result in legal consequences.
        </p>
      </div>`
    },
    {
        heading: "E-sign Disclosure & Consent",
        caption: "This policy describes how Supelle delivers communications to you electronically. We may amend this policy at any time by providing a revised version on our website....",
        body: `<div>
        <p>
          This policy describes how Supelle delivers communications to you
          electronically. We may amend this policy at any time by providing a revised
          version on our website. The revised version will be effective at the time we
          post it. We will provide you with prior notice of any material changes via
          our website.
        </p>
      
        <h6 class="mt-5 bold">Electronic Delivery of Communications</h6>
        <p>
          You agree and consent to receive electronically all communications,
          agreements, documents, notices, and disclosures that we provide in
          connection with your Supelle Account and your use of Wefreelancer Global
          Tech Services. Communications include:
        </p>
        <ul>
          <li>
            Terms of use and policies you agree to, including updates to these
            agreements or policies;
          </li>
          <li>
            Account details, history, transaction receipts, confirmations, and any
            other Account or transaction information;
          </li>
          <li>
            Legal, regulatory, and tax disclosures or statements we may be required to
            make available to you; and
          </li>
          <li>
            Responses to claims or customer support inquiries filed in connection with
            your Account.
          </li>
        </ul>
        <p>
          We will provide these communications to you by posting them on the Supelle
          website, emailing them to you at the primary email address listed in your
          Supelle profile, communicating to you via instant chat, and/or through other
          electronic communication such as text message or mobile push notification,
          as deemed appropriate.
        </p>
      
        <h6 class="bold mt-5">Hardware and Software Requirements</h6>
        <p>
          You may withdraw your consent to receive communications electronically by
          contacting us at
          <a href="http://supchain.io/support/index.html"
            >http://supchain.io/support/index.html</a
          >
          If you fail to provide consent or if you withdraw your consent to receive
          communications electronically, Supelle reserves the right to immediately
          close your Supelle Account or charge you additional fees for paper copies
        </p>
      
        <h6 class="bold mt-5">Updating Your Information</h6>
        <p>
          It is your responsibility to provide us with a true, accurate, and complete
          email address and your contact information, and to keep such information up
          to date. If Supelle sends you an electronic communication but you do not
          receive it because your primary email address on file is incorrect, out of
          date, blocked by your service provider, or you are otherwise unable to
          receive electronic communications, Supelle will be deemed to have provided
          the communication to you.
        </p>
        <p>
          You may update your information by logging into your account and visiting
          settings or by contacting our support team at
          http://supchain.io/support/index.html
        </p>
      </div>
      `
    },
    {
        heading: "General Terms and Conditions",
        caption: "This Terms of Service (“Agreement”) is a binding contract between you, an individual or entity user or authorized representative of such user...",
        body: `<div>
        <p>
          This Terms of Service (“Agreement”) is a binding contract between you, an
          individual or entity user or authorized representative of such user (“you”)
          and Wefreelancer Global Tech (the parent company of Supelle) and its wholly
          owned subsidiaries (herein referred to as “we,” “us,” or “our”). This
          Agreement governs your use of any website that links to these terms,
          including http://supchain.io/ (and all related subdomains) and its mobile
          applications (“Site”) and the services we provide (“Services”) regarding
          Digital Assets (“Digital Assets”) (sometimes called cryptocurrency).
        </p>
      
        <p>
          Supelle is not a bank, broker-dealer, or tax advisor and does not offer
          these or any related services.
        </p>
      
        <h6 class="bold">
          BY ACCESSING OR USING THE SITE OR OUR SERVICES, YOU AGREE THAT YOU HAVE
          READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THIS AGREEMENT. IF YOU DO NOT
          AGREE TO THIS AGREEMENT, THEN YOU MUST NOT ACCESS OR USE THE SITE OR OUR
          SERVICES.
        </h6>
        <p>
          If you are accessing the Site or using our Services on behalf of a business
          or corporate entity (“Organization”), then you hereby represent and warrant
          that you have the authority to bind that Organization, and your acceptance
          of this Agreement will be treated as acceptance by the Organization. In that
          event, “User” (defined above) and “you” in this Agreement will refer to the
          Organization.
        </p>
      
        <h6 class="bold mt-5">Material Terms</h6>
        <p>Under this Agreement, you acknowledge the following:</p>
        <ul>
          <li>
            You consent to the collection, use, and disclosure of information in
            accordance with and to be bound by the Supelle Privacy Policy (“Privacy
            Policy”);
          </li>
          <li>
            Our liability to you in connection with the site and services is limited,
            and you bear all risks associated with any participation on the site and
            in our services;
          </li>
          <li>
            We will resolve disputes arising under this Agreement through binding
            arbitration described further herein.
          </li>
        </ul>
      
        <h6 class="bold mt-5">General Terms and Conditions</h6>
        <p class="bold">Description</p>
        <p>The Site:</p>
        <p>
          (i) provides Users with general information about our products and services;
          and
        </p>
        <p>
          (ii) provides a platform for issuers to conduct compliant token-based
          transactions and events and for users to buy and sell cryptocurrencies.
        </p>
        <p>
          To the fullest extent permitted by law, and without limiting any other terms
          in this agreement, the following terms apply:
        </p>
        <p class="bold mt-5">Limitation of Liability</p>
        <p>
          To the extent permitted by law, we will not be liable for any direct,
          indirect, incidental, consequential, or punitive damages arising from or
          related to the use of our website, products, or services. This includes but
          is not limited to, damages for lost profits, lost revenue, or loss of data.
        </p>
      
        <h6 class="bold mt-4">No Guarantee</h6>
        <p>
          We make no representations regarding the likelihood or probability that your
          participation on the Site or in our Services will achieve a particular
          outcome or goal. You may lose all or part of any participation on the site
          and through our services. You further acknowledge and agree that We make no
          guarantees or other commitments about your ability to access or use the Site
          or Service.
        </p>
      
        <h6 class="bold mt-4">Information Submitted to Us; Identity Checks.</h6>
        <p>
          You are solely responsible for ensuring the accuracy and completeness of all
          information and materials that you provide to us in connection with your use
          of the Site or Services. You also acknowledge that you will immediately
          notify us about, and correct, any inaccuracy in any such materials or
          information. You acknowledge and authorize that we will check your
          background and identity as required by applicable laws in connection with
          certain uses of the site, either through direct checks or third-party
          investigations. You further acknowledge and agree that we may, in our sole
          discretion, deny you the right to use the site and will have no liability to
          you for any liability or other losses arising from any inquiries or
          investigations arising under this section.
        </p>
      
        <h6 class="bold mt-4">Wallets</h6>
        <p>
          You acknowledge and agree that we have no control over any wallet that you
          may use in connection with your use of the Site, other than a Supelle wallet
          or Supelle account, and any dispute between you and any third-party wallet
          provider is between you and that third-party wallet provider.
        </p>
      
        <h6 class="bold mt-4">Additional Terms and Changes</h6>
        <p>
          We may require you to agree to additional terms and/or changes in policies
          from time to time in connection with your use of the Site or Services.
          Except as expressly stated otherwise in such additional terms and changes,
          any additional terms or changes are hereby incorporated into and subject to
          this Agreement, and this Agreement will control in the event of any conflict
          or inconsistency with the additional terms or changes to the extent of the
          conflict or inconsistency. Your use of the Site or Services after any such
          addition or alteration described above will constitute your acceptance of
          the revised Agreement. If any change to this Agreement is not acceptable to
          you, then your sole remedy is to stop using the Site or Services.
        </p>
      
        <h6 class="bold mt-4">Consideration.</h6>
        <p>
          Supelle currently provides you with access to the Site for free. In return
          for enjoying this free access, you acknowledge and agree that we may
          generate revenues, increase goodwill or otherwise increase the value of
          Supchain (SUPC) from your use of the Site, and you will have no
          right to share in any such revenues, goodwill, or value whatsoever. However,
          we may charge you fees for certain Services and other uses of the Site. If
          we do, then we will notify you of those fees before you have an obligation
          to pay them.
        </p>
      
        <h6 class="bold mt-4">Jurisdictional Issues.</h6>
        <p>
          Anyone who chooses to access or use the Site or Services from locations
          outside the United States of America does so on their own initiative and is
          responsible for compliance with local laws, if and to the extent, local laws
          are applicable.
        </p>
      
        <h6 class="bold mt-4">Eligibility</h6>
        <p>
          <b
            >NEITHER THE SITE NOR THE SERVICES ARE FOR PERSONS UNDER THE AGE OF 18 OR
            FOR ANY USERS PREVIOUSLY SUSPENDED OR BLOCKED FROM THE SITE BY SUPELLE. IF
            YOU ARE UNDER 18 YEARS OF AGE, THEN YOU MUST NOT USE OR ACCESS THE SITE AT
            ANY TIME OR IN ANY MANNER.</b
          >
          Furthermore, by using the Site or Services, you affirm that you are at least
          18 years of age and otherwise have the legal capacity to contract, and have
          not been previously suspended or blocked from the Site by Supelle.
        </p>
      
        <h6 class="bold mt-4">Mobile Services</h6>
        <p>
          The Site will be accessible via a mobile phone, tablet, or other wireless
          devices (collectively, “Mobile Services”). Your mobile carrier’s normal
          messaging, data, and other rates and fees will apply to your use of the
          Mobile Services. You are solely responsible for checking with your mobile
          carrier to determine if our Mobile Services are available for your mobile
          device(s), what restrictions, if any, may apply to your use of the Mobile
          Services, and how much they will cost you. Supelle shall not be liable to
          any party for any loss or damage resulting in whole or in part from any
          malfunction in its Site or Service to you to the extent such malfunction
          arises from or is in any way connected to your mobile carrier’s service.
        </p>
      
        <h6 class="bold mt-4">Registration and Accounts</h6>
        <p class="bold">Log-In Credentials</p>
        <p>
          While you may always browse public-facing portions of the Site without
          registering with us, to access the password-protected portion of the Site,
          you must register an account with us or meet other criteria as will be
          required by us.
        </p>
      
        <h6 class="bold mt-4">Contact Information</h6>
        <p>
          You are responsible for keeping your email address and telephone number up
          to date in your Supelle profile to receive any notices or alerts that we may
          send you (including notices or alerts of actual or suspected Security
          Breaches).
        </p>
      
        <h6 class="bold mt-4">Account Security</h6>
        <p>
          You are responsible for the security of your account and are fully
          responsible for all activities that occur through the use of your
          credentials. You agree to notify us immediately at
          http://supchain.io/support/index.html if you suspect or know of any
          unauthorized use of your log-in credentials or any other breach of security
          concerning your Account. You must take any steps that we reasonably require
          to reduce, manage or report any security breach. Failure to provide prompt
          notification of any security breach may be taken into consideration in our
          determination of the appropriate resolution of the matter. We will not be
          liable for any loss or damage arising from the unauthorized use of your
          credentials.
        </p>
      
        <h6 class="bold mt-4">Revocation of Access</h6>
        <p>
          We reserve the right to disallow, cancel, remove, or reassign certain
          usernames and permalinks in appropriate circumstances, as determined by us
          in our sole discretion. We may also, with or without prior notice, suspend
          or terminate your account if activities occur on your account which, in our
          sole discretion, would or might constitute a violation of this Agreement,
          cause damage to or impair the Services or Site, infringe or violate any
          third party rights, damage or bring into disrepute the reputation of
          Supelle, or violate any applicable laws or regulations.
        </p>
      
        <h6 class="bold mt-4">Intellectual Property Rights</h6>
        <p class="bold">License</p>
        <p>
          Subject to your complete and ongoing compliance with this Agreement, Supelle
          hereby grants you a revocable, non-exclusive, non-transferable,
          non-sublicensable, royalty-free, and worldwide right and license to access
          and use the Services and Site solely in strict compliance with the
          provisions of this Agreement and as permitted by the functionalities of the
          Services and Site available to you.
        </p>
      
        <h6 class="bold mt-4">Content</h6>
        <p>
          The content that Supelle provides to you on the Services and Site,
          including, without limitation, any text, graphics, software, interactive
          features, information, or other materials, is protected by copyright or
          other intellectual property rights and owned by Wefreelancer Global Tech and
          its licensors. Moreover, Wefreelancer Global Tech or its licensors own all
          design rights, database and compilation rights, and other intellectual
          property rights in and to the Services and Site, in each case whether
          registered or unregistered, and any related goodwill.
        </p>
      
        <h6 class="bold mt-4">Marks</h6>
        <p>
          The Wefreelancer Global Tech and Supelle trademarks, service marks, and
          logos used and displayed on the Site are our registered and/or unregistered
          trademarks or service marks. Any other product and service names located on
          any part of the Services and Site may be trademarks or service marks owned
          by third parties. Except as otherwise permitted by law, you may not use the
          Trademarks to disparage Wefreelancer Global Tech, Supelle, or any applicable
          third party in any manner (using commercially reasonable judgment) that may
          damage any goodwill in the Trademarks. You may not use any Trademarks as
          part of a link to or from any website without our prior express written
          consent. All goodwill generated from the use of any Supelle Trademark will
          insure solely to Wefreelancer Global Tech and Supelle’s benefit.
        </p>
      
        <h6 class="bold mt-4">Infringement Policy</h6>
        <p>
          Supelle’s intellectual property policy is to remove or disable access to
          material that Supelle believes in good faith, upon notice from an
          intellectual property owner or his or her agent, is infringing the
          intellectual property of a third party by being made available through the
          Site. We reserve the right to promptly terminate the Accounts of repeat
          infringers.
        </p>
      
        <h6 class="bold mt-4">Restriction</h6>
        <p>
          Wefreelancer Global Tech (Supelle) hereby reserves all rights not expressly
          granted to you in this Section. Accordingly, nothing in this Agreement or on
          the Site will be construed as granting to you, by implication, estoppel or
          otherwise, any additional license rights in and to the Site, Service, or any
          Supelle Content or Trademarks located or displayed on or within the Site or
          Service.
        </p>
      
        <h6 class="bold mt-4">Content</h6>
        <p class="bold">General</p>
        <p>
          You represent and warrant that all User Profile Content, information, and
          other materials subject to intellectual property or similar laws that you
          provide, either directly or indirectly, to Supelle are owned by you or you
          otherwise have the lawful right to submit them. Such content should not
          require us to pay any amounts or provide any attribution to any third
          parties. For all User Content that you Submit, you hereby grant us (and the
          third parties we work with) a worldwide license to use, exploit, host,
          store, transmit, reproduce, modify, create derivative works of (such as
          those resulting from changes we make so that your User Content works better
          with our Site), publish, publicly perform and display and distribute such
          content; provided that we will not share with other Users any User Content
          that you Submit that is not viewable by other Users based on any privacy
          settings available on the Site.
        </p>
      
        <h6 class="bold mt-4">Disclaimer</h6>
        <p>
          We are under no obligation to edit or control the User Content that you
          submit, and will not be in any way responsible or liable for User Content.
          We may, however, at any time and without prior notice, screen, remove, edit,
          or block any User Content that in our sole judgment violates this Agreement
          or is otherwise objectionable. Furthermore, we may, in our sole discretion,
          take any action we deem necessary and/or appropriate against any User who
          submits objectionable content, including, but not limited to, warning the
          User or suspending or terminating the User’s Account.
        </p>
      
        <h6 class="bold mt-4">Restrictions on Use of the Site</h6>
        <p>
          Without limiting any other terms of this Agreement, you agree not to (and
          not to attempt to):
        </p>
        <ul>
          <li>
            decipher, decompile, disassemble, or reverse engineer any of the software
            or source code comprising or making up the Site;
          </li>
          <li>
            use any device, software, or routine to interfere or attempt to interfere
            with the proper working of the Services or Site, or any activity conducted
            thereon;
          </li>
          <li>
            delete or alter any material Wefreelancer Global Tech and Supelle make
            available on the Site;
          </li>
          <li>
            frame or link to any of the materials or information available on the
            Site;
          </li>
          <li>
            use or exploit any Trademarks or Supelle Content in any manner that is not
            expressly authorized by this Agreement;
          </li>
          <li>
            access, tamper with, or use non-public areas of the Site, Wefreelancer
            Global Tech’s (and its hosting company’s) computer systems, and
            infrastructure, or the technical delivery systems of Supelle’s providers;
          </li>
          <li>provide any false information to Supelle;</li>
          <li>
            create a false identity or impersonate another person or entity in any
            way;
          </li>
          <li>restrict, discourage, or inhibit any person from using the Site;</li>
          <li>
            use the Site, without Supelle’s prior express written consent, for any
            unauthorized purpose;
          </li>
          <li>
            gain unauthorized access to the Site, other Users’ Accounts, or to other
            computers or websites connected or linked to the Site or Service;
          </li>
          <li>
            transmit to the Site any virus, worm, spyware, malware, ransomware, or any
            other computer code, file, or program that may or is intended to disable,
            overburden, impair, damage, or hijack the operation of any hardware,
            software, or telecommunications equipment, or any other aspect of the Site
            or Services or communications equipment and computers connected thereto;
          </li>
          <li>
            violate any federal, state, or local laws or regulations or the terms of
            this Agreement; or
          </li>
          <li>
            assist or permit any person in engaging in any of the activities described
            above.
          </li>
        </ul>
        <p>
          It is Supelle’s policy to comply with all facially valid subpoenas, court
          orders, or binding orders issued to it by law enforcement agencies and other
          government authorities. This may affect your access to your account, your
          funds, and our services to you. We are not responsible for any losses,
          whether direct or indirect, that you may incur as a result of our compliance
          with applicable laws and regulations, the guidance or direction of any
          regulatory authority or government agency, or any writ of attachment, lien,
          levy, subpoena, warrant, or other legal order.
        </p>
      
        <h6 class="bold mt-4">Feedback</h6>
        <p>
          If you have any feedback, questions, or complaints, write to us at
          http://supchain.io/support/index.html
        </p>
      
        <h6 class="bold mt-4">Arbitration; Waiver of Class Action.</h6>
        <p class="bold">
          By accepting this agreement, you and Wefreelancer Global Tech are each
          waiving the right to a trial by jury or to participate in a class action.
        </p>
        <p>
          You may be requested to provide us with your personal data, such as KYC
          documents in case of a dispute between you and Us or to comply with legal
          and regulatory requirements. In such cases, we expect you to provide us with
          the requested information for further processing and action.
        </p>
        <p>
          The parties will attempt to resolve all disputes, controversies, or claims
          arising under, out of, or relating to the Site or Content or to these Terms,
          in accordance with the procedures outlined in this Section. Except as noted
          below, if any Dispute cannot be resolved through negotiations between the
          parties within 5 days of notice from one party to the other of the Dispute,
          such Dispute will be finally settled through binding arbitration under the
          arbitration of the American Arbitration Association (AAA) then in effect
          (the Rules). Either party may commence the arbitration by delivering a
          request for arbitration as specified in the Rules. The arbitration will be
          conducted before a sole neutral arbitrator selected by the agreement of the
          parties.
        </p>
      
        <p>
          If the parties cannot agree on the appointment of a single arbitrator within
          30 days (the Initial Period) after either party to these Terms delivers a
          request for arbitration, a neutral arbitrator will be selected as provided
          in the Rules. The arbitration will be conducted exclusively in the English
          language at a site specified by Supelle in the USA. The arbitrator’s award
          will be the parties’ exclusive remedy for all claims, counterclaims, issues,
          or accountings presented or pleaded to the arbitrator. The arbitrator’s
          award will require payment of the costs, fees, and expenses incurred by the
          prevailing party in any such arbitration by the non-prevailing party.
        </p>
        <p>
          Judgment upon the award may be entered in any court or governmental body
          having jurisdiction thereof. Any additional costs, fees, or expenses
          incurred in enforcing the award may be charged against the party that
          resists its enforcement. To the fullest extent permitted by applicable law,
          no arbitration shall be joined to an arbitration involving any other party
          subject to these Terms, whether through class arbitration proceedings or
          otherwise. Notwithstanding the foregoing, you agree that the following
          matters shall not, at the election of Supelle, be subject to binding
          arbitration: (a) any dispute concerning Supelle or its suppliers or service
          providers’ Intellectual Property Rights; (b) any dispute related to or
          arising from allegations of criminal activity; or (c) any claim for
          injunctive relief.
        </p>
        <p>
          Supelle’s liability to you or any third parties in any circumstance arising
          from this agreement is limited to U.S. $100.
        </p>
      
        <h6 class="bold mt-4">Third-Party Disputes</h6>
        <p>
          Any dispute you have with any third party, including other users, in
          connection with your use of the site or services is directly between you and
          such third party. Accordingly, to the fullest extent permitted by law, you
          hereby irrevocably release Wefreelancer Global Tech and Supelle from any and
          all claims, demands, and damages (actual and consequential) of every kind
          and nature, known and unknown, arising out of or in any way connected with
          such disputes.
        </p>
      
        <h6 class="bold mt-4">Term and Termination of the Agreement</h6>
        <p class="bold">Term</p>
        <p>
          As between you and Supelle, the term of this Agreement commences on your
          first use of the Site or Services and continues until the termination of
          this Agreement by either you or Supelle.
        </p>
      
        <h6 class="bold mt-4">Suspension, Termination, and Cancellation</h6>
        <p>
          You may terminate this Agreement by notifying us via
          http://supchain.io/support/index.html and terminating your use of the Site
          and Services. We reserve the right, in our sole discretion, to restrict,
          suspend, or terminate your access to all or any part of the Site or Service,
          or to terminate this Agreement at any time without prior notice or liability
          if you breach any provision of this Agreement or violate the rights of any
          third party on or through the Site.
        </p>
        <p>
          We reserve the right to change, suspend, or discontinue all or any part of
          the Site at any time without prior notice or liability. Also, any of the
          content on our Site may be out of date at any given time, and we are under
          no obligation to update it.
        </p>
      
        <h6 class="bold mt-4">Consent to Electronic Communications</h6>
        <p>
          By using the Site, you consent to receive certain electronic communications
          from us as further described in the E-sign Disclosure and Privacy Policy.
        </p>
      
        <h6 class="bold mt-4">Miscellaneous</h6>
        <ul>
          <li>
            No joint venture, partnership, employment, or agency relationship exists
            between you and Wefreelancer Global Tech as a result of this Agreement or
            use of the Site or Services.
          </li>
          <li>
            If any provision of this Agreement is found to be invalid by any court or
            arbitrator having competent jurisdiction, then the invalidity of such
            provision will not affect the validity of the remaining provisions of this
            Agreement, which will remain in full force and effect.
          </li>
          <li>
            Failure of Wefreelancer Global Tech or Supelle to act on or enforce any
            provision of this Agreement will not be construed as a waiver of that
            provision or any other provision in this Agreement.
          </li>
          <li>
            No waiver will be effective against Wefreelancer Global Tech unless made
            in writing, and no such waiver will be construed as a waiver in any other
            or subsequent instance.
          </li>
          <li>
            This Agreement constitutes the entire agreement between you and
            Wefreelancer Global Tech with respect to the subject matter hereof and
            supersedes all previous or concurrent agreements, whether written or oral,
            between the parties concerning the subject matter hereof.
          </li>
          <li>
            The Section headings are provided merely for convenience and will not be
            given any legal import.
          </li>
          <li>
            This Agreement will ensure to the benefit of our successors and assigns,
            without restriction.
          </li>
          <li>
            You may not assign this Agreement or any of the rights or licenses granted
            hereunder without the prior express written consent of Supelle.
            “Assignment” as used in the prior sentence includes any changes of control
            or sale of stock or assets of any Organization.
          </li>
          <li>
            You acknowledge and agree that you have had the opportunity to consult
            legal counsel in connection with this Agreement even if you chose not to
            do so, and this Agreement will not be construed against you or
            Wefreelancer Global Tech (Supelle) as drafter.
          </li>
        </ul>
      
        <h6 class="bold mt-4">Contact Us</h6>
        <p>
          If you would like to contact us for any reason, you can do so at
          http://supchain.io/support/index.html
        </p>
      </div>`
    },
    {
        heading: "Privacy Policy",
        caption: "Wefreelancer Global Tech, Supelle, and its wholly-owned, separately operated subsidiaries (collectively “We” and “Us”) value the privacy of individuals...",
        body: `<div>
        <small>Last updated: 07/16/23</small>
      
        <p class="mt-4">
          Wefreelancer Global Tech, Supelle, and its wholly-owned, separately operated
          subsidiaries (collectively “We” and “Us”) value the privacy of individuals
          who visit http://supchain.io/ and any of our other websites, applications, or
          services that link to this Privacy Policy (collectively, the “Service”). The
          Service users who buy, sell or trade cryptocurrencies or utility tokens will
          be collectively referred to as “User(s)”. This Privacy Policy (“Policy”) is
          designed to explain how we collect, use, and share information from Users of
          the Service and is incorporated by reference into our Terms of Service.
        </p>
      
        <p>
          The User, by agreeing to this Policy in the account setup and through the
          continued use of the Service, agrees to the terms and conditions of the
          Policy.
        </p>
      
        <h6 class="bold mt-4">Information We Collect</h6>
        <p>We generally collect any information the User provides to Us when using the Service. The common mediums include:
        </p>
      
        <ul>
          <li> <b>Registration and Identification:</b> We collect all User information that is required and provided at registration, as well as documentation provided for identity verification.</li>
          <li> <b>Financial Information:</b> We may collect Users’ necessary financial information such as bank routing numbers and account numbers. This is majorly to enable trading cryptocurrency and/or utility tokens using traditional fiat currency and/or cryptocurrency.</li>
          <li> <b>Communications:</b> We may collect additional information when Users contact us directly.</li>
        </ul>
      
        <p>This information includes (but is not limited to):</p>
        <ol style="list-style: upper-alpha;">
          <li>personal information that links back to an individual, e.g., name, date of birth, and other personal identification numbers;</li>
          <li>contact information, e.g., address, phone number, email address, Ethereum wallet address;</li>
          <li>technical information, e.g., IP address for API services and logins</li>
          <li>statistical data, e.g., hits to the website.</li>
        </ol>
      
        <p class="bold">Information We Collect Automatically From Users’ Use of the Service (Cookie Policy)</p>
        <p>When Users use our Service, we may collect information from them through automated means, such as cookies, web beacons­­­, and web server logs. </p>
        <p>Cookies are text files, containing small amounts of information, which are downloaded to your browsing device, such as your computer, mobile device, or smartphone, when you use our Services. Web beacons are small, transparent image files used by websites and emails to track user behavior and gather information about their preferences and interests. Web server logs are files that contain information about every request made to a web server, including the IP address of the user, the time and date of the request, and the page or resource that was requested.</p>
        <p>By using the Service, Users consent to the placement of cookies, beacons, and similar technologies in their browsers and on emails in accordance with the Policy. The information collected in this manner includes IP address, browser characteristics, device IDs and characteristics, operating system version, language preferences, referring URLs, and information about the usage of our Service.</p>
      
        <p>We may use this information for analytics purposes and to optimize the Service. If a User does not want information collected through the use of cookies, Users can decline the use of cookies on their browser. If, however, Users do not accept cookies, they may experience some inconvenience in their use of the Service.</p>
      
        <p class="bold">How We Use Users’ Information</p>
        <p>We may use the information we collect:</p>
        <ul>
          <li>To verify the identity and accreditation status of Users</li>
          <li>To facilitate participation in the Service.</li>
          <li>To optimize features of the Service, to provide services and information that the User requests, to respond to comments and questions, and otherwise to provide support to Users.</li>
          <li>To develop new products, services, features, and functionality.</li>
          <li>To contact Users for administrative or informational purposes, such as communicating changes to terms, conditions, and policies.</li>
          <li>For marketing purposes, such as developing and providing promotional and advertising materials that may be useful, relevant, valuable, or otherwise of interest.</li>
          <li>To personalize the User experience on the Service by presenting tailored content.</li>
          <li>For Supelle business purposes, such as audits, security, compliance with applicable laws and regulations, fraud monitoring, and prevention.</li>
          <li>To enforce the Terms of Service or other legal rights.</li>
        </ul>
      
        <p class="bold">How We Share Users' Information</p>
        <p>We may disclose information that We collect through the Service to third parties in the following circumstances:</p>
        <ul>
          <li>To credit bureaus and other third parties who provide know-your-customer and anti-money laundering services, including verifying users as accredited contributors.</li>
          <li>To Supelle third-party service providers who provide services such as website hosting, data analysis, customer service, email delivery, auditing, and other services.</li>
          <li>To a potential or actual acquirer, successor, or assignee as part of any reorganization, merger, sale, joint venture, assignment, transfer, or other disposition of all or any portion of the business, assets, or stock (including in bankruptcy or similar proceedings).</li>
          <li>If required to do so by law or in the good faith belief that such action is appropriate:
            <ul style="list-style: none;">
              <li>(a) under applicable law, including laws outside the User’s country of residence;</li>
              <li>(b) to comply with legal process;</li>
              <li>(c) to respond to requests from public and government authorities, including public and government authorities outside the User’s country of residence;</li>
              <li>(d) to enforce our terms and conditions;</li>
              <li>(e) to protect Supelle operations or those of any of its subsidiaries;</li>
              <li>(f) to protect Supelle’s rights, privacy, safety or property, and/or that of its subsidiaries, the User’s, or others; and</li>
              <li>(g) to allow Us to pursue available remedies or limit the damages that We may sustain.</li>
            </ul>
          </li>
        </ul>
      
        <p class="bold mt-4">How Long We Keep Your Information</p>
        <p>We will only keep the User’s personal information for as long as it is necessary for the purposes set out in the Policy, unless a longer retention period is required or permitted by law (such as tax, accounting, or other legal requirements).</p>
        <p>
          We delete or anonymize the User’s personal information as soon as We have no ongoing legitimate business need to process it.
          </p>
      
        <p class="bold mt-4">Third-Party Services</p>
        <p>We may display third-party content on the Service. Third-party content may use cookies, web beacons, or other mechanisms for obtaining data in connection with the User’s viewing of and/or interacting with the third-party content on the Service. The Policy does not address, and Supelle is not responsible for, the privacy, information, or other practices of any third parties. The inclusion of a third-party link on the Service does not imply that We or any of our affiliates endorse the linked website.</p>
      
        <p class="bold mt-4">Security</p>
        <p>We have put in place the best mechanisms possible to maintain the integrity and security of the information that We collect. Please be aware that no security measures are perfect or impenetrable and thus, We can only guarantee the security of Users’ data to reasonable extents. Please Users should ensure that they do not share passwords or other sensitive information with anyone.</p>
      
        <p class="bold mt-4"></p>
        <p></p>
      
        <p class="bold mt-4">International Cross-border Data Transfer</p>
        <p>Supelle uses servers hosted in the United States. By using the Service, the User consents to the possible transfer of information to countries outside of their country of residence, including the United States, which may have data protection rules that are different from those of their country.</p>
      
        <p class="bold mt-4">Your Rights and Choices</p>
        <p>Depending on the User’s country of residence and its legislation, the User may have the right to request from us a copy of your personal data, as well as to delete your personal data, make amendments to it, or restrict its processing. We will endeavor to provide the information back to you as soon as practicable. However, we also reserve the right to validate all requests for authenticity of the request. <br> <br>
      
          The User may choose not to accept cookies. But, please be advised that if you do not accept cookies the service might be difficult or impossible to use. The User may also decline to share other information with Us. In such cases, we may not be able to provide the User with some or all of the features and functionality of the Service. <br><br>
          
          The User may also choose to opt out of marketing e-mails, newsletters, and the like.
          </p>
      
        <p class="bold mt-4">Account Changes and Closure</p>
        <p>The User may at any time review or change the information in their Supelle account or request closure of their account by contacting Us.
        </p>
        
        <p class="bold mt-4">Use of Service by Minors</p>
        <p>The Service is not directed to individuals under the age of eighteen (18), and We request that no person provides personal information through the Service if they are under 18 years old.</p>
      
        <p class="bold mt-4">Updates to the Privacy Policy</p>
        <p>We may make changes to the Policy. The “Last Updated” date at the top of this page indicates when this Policy was last revised. If We make material changes, We may notify the User through the Service or by sending an email or other communication. We encourage the Users to read the Privacy Policy periodically to stay up-to-date about Supelle privacy practices. The User’s use of the Service following these changes means that the User accepts the revised Privacy Policy.
        </p>
      
        <p class="bold mt-4">Contact Us</p>
        <p>If you have any questions about the Privacy Policy please contact us at:
        http://supchain.io/support/index.html</p>
      </div>
      `
    },
    {
        heading: "Risk Disclosure",
        caption: "Wefreelancer Global Tech (the parent company of Supelle) believes that cryptocurrency is the future of finance. Hence, we are proudly collaborating with experts,...",
        body: `<div>
        <p class="bold">
          Important Information on Cryptocurrency and Digital Asset Risk
        </p>
        <p>
          Wefreelancer Global Tech (the parent company of Supelle) believes that
          cryptocurrency is the future of finance. Hence, we are proudly collaborating
          with experts, industry leaders, and policymakers in the U.S. and
          internationally as we develop our platform. However, while this digital
          platform is full of potential and promise, it does have certain risks
          involved.future
        </p>
      
        <p>
          We encourage all users of cryptocurrencies and digital assets to conduct
          their own due diligence before opening an account and/or buying, selling, or
          trading cryptocurrencies and digital assets. Please evaluate your particular
          financial circumstances to determine whether or not trading cryptocurrencies
          is appropriate for you.
        </p>
      
        <p>
          Do not contribute funds in cryptocurrencies that you cannot afford to lose.
          Transactions in cryptocurrency may be irreversible, and, accordingly, losses
          due to accidental transactions, changes in the ecosystem, etcetera may not
          be recoverable.
        </p>
        <p class="bold">Potential Tax Implications.</p>
        <ol>
          <li class="mb-3"><b>Capital Gains:</b> If you buy and hold digital or virtual currencies as an investment, you may be subject to capital gains taxes when you sell them for a profit. The tax rate will depend on how long you held the asset and your tax bracket.</li>
          <li class="mb-3">
            <b>Income:</b> If you receive digital or virtual currencies as payment for goods or services, this income may be taxable. The value of the currency at the time you receive it would be included in your gross income for tax purposes.
          </li>
          <li class="mb-3"><b>Foreign Accounts:</b> If you hold digital or virtual currencies in foreign accounts, you may be required to report those accounts to your government and pay taxes on any income earned from them.</li>
        </ol>
      
        <p class="bold mb-4">Consult with a Professional: </p>
        <p>Laws and regulations regarding digital and virtual currencies are still evolving, and there may be additional tax implications in the future. We recommend that you consult with a licensed tax professional to fully understand your tax obligations when using digital or virtual currencies.
        </p>
      
        <p class="bold mb-4">Account Insurance</p>
        <p>Any insurance or surety bonds maintained by Supelle for the benefit of its customers may not be sufficient to cover all potential losses incurred by customers. </p>
      
        <p class="bold mb-4">Cryptocurrency and Digital Asset Features</p>
        <p>Cryptocurrencies and other digital assets are digital representations of value that function as a medium of exchange, a unit of account, or a store of value but do not have legal tender status. Cryptocurrencies are sometimes exchanged for U.S. dollars or other fiat currencies around the world, but they are not generally backed or supported by any government or central bank. Their value is completely derived from market forces of supply and demand, and they are more volatile than traditional currencies.
        </p>
        <p>Cryptocurrencies and other digital assets are subject to changes or may otherwise cease to operate as expected due to changes made to their underlying technology, changes made using their underlying technology, or other general changes, whether anticipated or unpredicted. These changes can include, but are not limited to, forks, rollbacks, airdrops, or bootstraps.</p>
      
        <ul class="mt-4">
          <li>Fork: A split in the blockchain network.</li>
          <li>Rollback: A reversal of a transaction on the blockchain.</li>
          <li>Airdrop: A distribution of tokens to users for free.</li>
          <li>Bootstrap: The initial distribution of tokens in a new cryptocurrency network.</li>
        </ul>
      
        <p class="bold mt-4">Government Regulations and Legal Solutions</p>
        <p>Future legislative and regulatory changes or actions at the state, federal, or international level may adversely affect the use, transfer, exchange, and value of cryptocurrency and other digital assets.
        </p>
        <p>In addition, cryptocurrency markets and exchanges are not regulated with the same controls or customer protections available in equity, option, futures, or foreign exchange contributing. There is no assurance that a person who accepts a cryptocurrency as payment today will continue to do so in the future, and there may be few, if any, options regarding legal solutions.</p>
      
        <p class="bold mt-4">Transactions and Other Fees</p>
        <p>While Supelle does guarantee to keep our transaction fees as low as possible, the amounts of these fees are subject to market forces. As we do our best to render the best services we can, it is possible that the fees could increase substantially during a period of increased activity or volatility.
        </p>
        
        <p>You can learn more about our fees here.</p>
      
        <p class="bold mt-4">Additional Resources</p>
        <p>Wefreelancer Global Tech collaborates closely with federal, state, and international regulators to build our platform. For more information regarding cryptocurrencies, digital assets, and their associated risks, check out:</p>
      
        <ul>
          <li>Consumer Financial Protection Bureau (CFPB) Consumer Advisory</li>
          <li>Financial Industry Regulatory Authority (FINRA)’s Cryptocurrencies Hub</li>
          <li>Commodity Futures Trading Commission (CFTC) Virtual Currencies</li>
        </ul>
      </div>
      `
    },
]

export default legals